import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, MapPinIcon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
const FIRST_DELAY = 5000;
const VISIBLE_MS = 6000;
const HIDDEN_MS = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const timeout = window.setTimeout(() => {
      if (visible) {
        setVisible(false);
        setIndex(prev => (prev + 1) % recentBuyers.length);
      } else {
        setVisible(true);
      }
    }, visible ? VISIBLE_MS : index === 0 ? FIRST_DELAY : HIDDEN_MS);
    return () => window.clearTimeout(timeout);
  }, [visible, index, dismissed]);
  const buyer = recentBuyers[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-3 left-3 z-50 max-w-[15rem]" data-id="element-123" data-mp="1gx2t254uzpug">
      <AnimatePresence data-id="element-124" data-mp="116wb2t5x7jh0">
        {visible && !dismissed && <motion.div key={buyer.name} initial={{
        opacity: 0,
        y: 12,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.97
      }} transition={{
        duration: 0.25,
        ease: EASE
      }} className="pointer-events-auto flex items-start gap-2 rounded-xl border-[3px] border-electric bg-gold p-2 shadow-[0_6px_18px_rgba(7,27,58,0.35)]" data-id="element-125" data-mp="116mh6uhr8s61">
            <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-navy" data-id="element-126" data-mp="x51a5prwj83r">
              <CheckIcon size={13} className="text-gold" strokeWidth={3} aria-hidden="true" data-id="element-127" data-mp="s5olr0ldtsz2" />
            </span>
            <div className="min-w-0" data-id="element-128" data-mp="28jogzy9a8ufz">
              <p className="font-display text-[0.72rem] font-extrabold leading-tight text-navy" data-id="element-129" data-mp="28imyx9tun7or">
                {buyer.name} compró el Mega Pack Técnico en Seguridad Electrónica
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-[0.64rem] font-semibold text-navy/80" data-id="element-130" data-mp="2aobgywl24h0q">
                <MapPinIcon size={10} aria-hidden="true" data-id="element-131" data-mp="2fpr1mnjbolil" />
                {buyer.city}, Argentina · hace {buyer.minutes} min
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar aviso" className="shrink-0 rounded p-0.5 text-navy/70 transition-colors duration-150 ease-soft hover:text-navy" data-id="element-132" data-mp="2pksofcq4lbi0">
              <XIcon size={13} aria-hidden="true" data-id="element-133" data-mp="21wj6wmzy39wo" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}